module.exports = __webpack_public_path__ + "img/icon-news.a1729595.png";